import { Location } from 'history';
import React, { useState, useEffect } from 'react';
import { Prompt as RouterPrompt, useHistory } from 'react-router';
// eslint-disable-next-line import/no-extraneous-dependencies

interface PromptActions {
  onConfirm: () => void;
  onClose: () => void;
}

interface PromptProps {
  children: (actions: PromptActions) => JSX.Element;
  when: boolean;
}

const preventChange = (e: BeforeUnloadEvent) => {
  e.preventDefault();
  e.returnValue = '';
};

export const Prompt: React.FC<PromptProps> = ({ when, children }) => {
  const history = useHistory();
  const [nextLocation, setNextLocation] = useState<Location>();
  const [blocking, setBlocking] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line no-unneeded-ternary
    setBlocking(nextLocation ? false : true);
  }, [nextLocation]);

  // Block in-browser url change
  useEffect(() => {
    if (when) {
      window.addEventListener('beforeunload', preventChange);
    }

    return () => {
      window.removeEventListener('beforeunload', preventChange);
    };
  }, [when]);

  const handleMessage = (location: Location) => {
    setNextLocation(location);

    // Block router location change
    return false;
  };

  const onConfirm = () => {
    if (nextLocation) {
      window.removeEventListener('beforeunload', preventChange);

      history.push(nextLocation.pathname, nextLocation.state);
    }
  };

  const onClose = () => {
    setNextLocation(undefined);
  };

  return (
    <>
      <RouterPrompt when={blocking ? when : false} message={handleMessage} />
      {nextLocation && children({ onConfirm, onClose })}
    </>
  );
};
